import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['counter']

  connect() {
    this.updateCounterFromServer()
    this.interval = setInterval(() => this.updateCounterFromServer(), 60000)
  }

  disconnect() {
    if (this.interval) clearInterval(this.interval)
  }

  updateCounterFromServer() {
    fetch('/kanban_boards/unseen_count', {
      headers: {
        'Accept': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content
      }
    })
      .then(r => r.json())
      .then(data => this.updateCounterValue(data.count))
      .catch(() => {})
  }

  updateCounterValue(count) {
    if (!this.hasCounterTarget) return
    if (count > 0) {
      this.counterTarget.textContent = count
      this.counterTarget.classList.remove('hidden')
    } else {
      this.counterTarget.classList.add('hidden')
    }
  }
}
